import { isValidUrl } from '@src/app/utils/domainHelpers';
import { getConfig } from '@superbet-group/web.lib.config';
import BonusProvider from '@core/models/bonus/BonusProvider';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { WelcomeBonus } from '@core/models/bonus/WelcomeBonus';

export function getTermsAndConditionsUrl(termsUrl: string | undefined) {
    return termsUrl && isValidUrl(termsUrl) ? termsUrl : undefined;
}

export function getWelcomeOfferModalData(welcomeBonuses: WelcomeBonus[], shouldShowIntroModal = true) {
    const bonusConfig = getConfig().countrySpecific.user.bonus;

    return bonusConfig.bonusProvider === BonusProvider.Betler
        ? {
            code: modalCodes.welcomeOffer,
            goBack: false,
            isClosable: false,
            data: {
                welcomeBonuses: welcomeBonuses,
            },
        }
        : {
            code: bonusConfig.isWelcomeBonusIntroModalVisible && shouldShowIntroModal
                ? modalCodes.welcomeBonusIntro
                : modalCodes.welcomeBonus,
        };
}
